import { gql } from "@apollo/client";

export const DESARROLLO_FRAGMENT = gql`
  fragment DesarrolloFragment on Desarrollo {
    id
    folio
    fechaCreacion
    prospecto {
      id
      tipoCliente
      nombre
      atendidoPorId
      datosFiscalId
      apellidos
      ocupacion
      numeroHA
      nombreComercial
      razonSocialFiscal
      direccionFiscal {
        id
        direccionTipo
        comentarios
        direccion {
          id
          codigoPostal
          numeroExterior
          numeroInterior
          calle
          colonia
          municipio
          estado
        }
      }
    }

    desarrolloProductos {
      id
      cantidad
      unidadMedidaId
      unidadMedida {
        id
        nombre
      }
      precio
      flete
      fleteUnitario
      total
      subtotal
      subtotal_prod
      iva
      descuento
      descuentoDato
      estatusProducto
      comentarios
      dosisJSON
      producto {
        id
        codigo
        nombre
        cantidad
        empaque
        marca
        hasIva
        unidadMedidaPresentacion {
          id
          nombre
          acronimo
        }
      }
    }
    cultivoId
    visiteo
    cultivo {
      nombre
    }
    tamanoMuestra
    importe
    patrocinio
    total
    fechaInicio
    fechaFin
    estatusDesarrollo
    comentarios
    esPrincipal
    usuario {
      persona {
        nombre
        apellidoPaterno
        apellidoMaterno
      }
    }
  }
`;

export const OBTENER_PAGINADO_DESARROLLOS = gql`
  query DesarrollosPage(
    $query: QueryInput!
    $vendedorId: ID
    $estatus: EstatusDesarrolloEnum
    $prospectoId: ID
  ) {
    desarrollos {
      obtenerPaginado(
        query: $query
        vendedorId: $vendedorId
        estatus: $estatus
        prospectoId: $prospectoId
      ) {
        totalItems
        items {
          ...DesarrolloFragment
          prospectoId
          puedeFinalizar
        }
      }
    }
  }
  ${DESARROLLO_FRAGMENT}
`;

export const OBTENER_DESARROLLOS_PORID = gql`
  query ObtenerPorIdAsync($id: ID!) {
    desarrollos {
      obtenerPorIdAsync(id: $id) {
        id
        folio
        razonSocial
        comentarios
        total
        subtotal
        iva
        patrocinio
        importe
        prospecto {
          id
          nombre
          apellidos
          ocupacion
          correo
          numeroHA
          numeroSucursales
          razonSocialFiscal
          direccionFiscal {
            id
            direccionTipo
            comentarios
            nombreDomicilio
            direccion {
              id
              codigoPostal
              numeroExterior
              numeroInterior
              calle
              colonia
              municipio
              estado
            }
          }
          listaContactos {
            id
            correo
          }
          atendidoPor {
            persona {
              nombre
              apellidoPaterno
              apellidoMaterno
              telefonoInstitucional
              correoInstitucional
            }
          }
        }
        desarrolloProductos {
          id
          cantidad
          unidadMedidaId
          unidadMedida {
            id
            nombre
          }
          precio
          flete
          fleteUnitario
          total
          subtotal
          subtotal_prod
          iva
          descuento
          descuentoDato
          comentarios
          producto {
            id
            codigo
            nombre
            cantidad
            empaque
            marca
            unidadMedidaPresentacion {
              id
              nombre
              acronimo
            }
          }
        }
        total
        estatusDesarrollo
        usuario {
          id
          persona {
            nombre
            apellidoPaterno
            apellidoMaterno
          }
        }
      }
    }
  }
`;

export const OBTENER_DESARROLLO_PORID = gql`
  query DesarrollosPage($id: ID!) {
    desarrollos {
      obtenerDesarrolloPorId(id: $id) {
        ...DesarrolloFragment
        desarrolloProductos {
          id
          aplicaciones
          cantidad
          dosisJSON
          precio
          estatusProducto
          productoId
          producto {
            id
            codigo
            nombre
            marca
            empaque
            cantidad
            unidadMedidaPresentacion {
              id
              nombre
              acronimo
            }
          }
          unidadMedidaId
          unidadMedida {
            id
            nombre
            acronimo
          }
        }
      }
    }
  }
  ${DESARROLLO_FRAGMENT}
`;

export const OBTENER_DESARROLLO_CON_LISTA_IMAGENES = gql`
  query ($id: ID!) {
    desarrollos {
      obtenerPorIdAsync(id: $id) {
        id
        ordenVenta {
          id
          direccionEnvio {
            id
            calle
            codigoPostal
            colonia
            municipio
            estado
            numeroExterior
          }
        }
        listaActividades {
          id
          fechaHora
          asignadosJSON
          listaGaleriaImagen {
            id
            isTestigo
            isTratamiento
            comentario  
            documento {
              id
              url
            }
          }
        }
      }
    }
  }
`;